import { Type } from '@angular/core';
import { OrderRequestEffects } from './order-request.effect';

export const effects: Type<object>[] = [
    OrderRequestEffects,
];